import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import Icon from '../Icon';
import ResponsiveImage from '../ResponsiveImage';
import { translate } from '../../Services/translation';
import MegaMenuColumn from './MegaMenuColumn';
import { debounce } from 'lodash-es';

const CLOSE_DELAY = 250;
const DEBOUCE_DELAY = 200;

const MegaMenu = ({
  open,
  onMegaMenuClose,
  onMouseOverMegaMenu,
  onMouseLeaveMegaMenu,
  link,
}) => {
  const [columns, setColumns] = useState([link]);
  const [imageColumn, setImageColumn] = useState(null);
  const [activeLinks, setActiveLinks] = useState([]);

  const debouncedHandleMouseEnter = debounce(
    (link, colIndex) => handleMouseEnter(link, colIndex),
    DEBOUCE_DELAY
  );

  const handleMouseEnter = (link, colIndex) => {
    const columnsCopy = [...columns];
    const activeLinksCopy = [...activeLinks];

    // Clear all links to the right of this link
    columnsCopy.splice(colIndex + 1);
    activeLinksCopy.splice(colIndex);
    setImageColumn(null);

    if (!activeLinks.length) {
      setActiveLinks([link]);
    } else if (!activeLinksCopy.includes(link)) {
      activeLinksCopy.push(link);
      setActiveLinks(activeLinksCopy);
    }

    if (!columnsCopy.includes(link) && !!link.links.length) {
      columnsCopy.push(link);
    }

    if (!link.links.length && link.responsiveImage) {
      setImageColumn({
        image: link.responsiveImage,
        name: link.name,
        url: link.url,
      });
    }

    setColumns(columnsCopy);
  };

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setColumns([link]);
        setImageColumn(null);
        setActiveLinks([]);
      }, CLOSE_DELAY);
    }
  }, [open]);

  return (
    <div
      className={clsx('mega-menu', open && 'mega-menu--open')}
      onMouseLeave={onMouseLeaveMegaMenu}
      onMouseOver={onMouseOverMegaMenu}
    >
      <div className="mega-menu__columns">
        {columns.map((col, idx) => (
          <MegaMenuColumn
            link={col}
            onLinkEnter={debouncedHandleMouseEnter}
            key={`columns-level-${idx}`}
            columnIndex={idx}
            activeLinks={activeLinks}
          />
        ))}
        {imageColumn && (
          <div className="mega-menu__column mega-menu__column--image">
            <a
              href={imageColumn.url}
              className="mega-menu__image-column-anchor"
            >
              {imageColumn.image && (
                <figure className="mega-menu__image-wrapper">
                  <ResponsiveImage
                    {...imageColumn.image}
                    className="mega-menu__image"
                  />
                </figure>
              )}
              {imageColumn.name && (
                <div className="mega-menu__image-column-name">
                  {imageColumn.name}
                  <Icon
                    name="Arrow-Right"
                    size={24}
                    className="mega-menu__image-column-icon"
                  />
                </div>
              )}
            </a>
          </div>
        )}
      </div>
      <button
        className="mega-menu__close"
        onClick={onMegaMenuClose}
        aria-label={translate('megamenu.close.sc')}
      >
        <Icon name="Close" className="mega-menu__close-icon" size={24} />
      </button>
    </div>
  );
};

export default MegaMenu;
